module.exports = __webpack_public_path__ + "img/gxcc.c1ec4972.png";